import React from 'react';

import { Shimmer, Table } from '@betterment/samba-react';
import { range } from 'es-toolkit/compat';

import { BulkFeeIntentsColumns } from '../data';

interface BulkFeeIntentsLoadingProps {
  columns: BulkFeeIntentsColumns[];
  pageSize: number;
}

export const BulkFeeIntentLoading: React.FC<BulkFeeIntentsLoadingProps> = ({ columns, pageSize }) => {
  return range(pageSize).map(row => (
    <Table.Row key={row}>
      {range(columns.length).map(index => {
        return (
          <Table.Cell key={`${row}-${index}`}>
            <Shimmer css={{ height: '12px', width: '70%' }} />
          </Table.Cell>
        );
      })}
    </Table.Row>
  ));
};
